import { format as formatDate } from 'date-fns';
import { parenthesesContent } from './regex';

export const toDateStr = date => {
    return (date ? formatDate(new Date(date), 'dd-MMM-yyyy') : '');
}

export const dateRange = date => formatDate(new Date(date), 'yyyy-MM-dd');

const getNameFromEmail = emailId => {
    if (emailId === null || emailId === undefined || emailId === '') {
        return emailId;
    } else {
        let result = emailId.match(parenthesesContent);
        return result === null ? emailId : result[1];
    }
};
export default getNameFromEmail;
